import { observable } from 'mobx';
import Abstract from './abstract';

const scenes = ['main', 'catalog', 'editLock', 'editAuditSwitch', 'mixedCourseware'];
const defaults = {
  current: 0,
  visible: true,
};

export class Guide extends Abstract {
  @observable public main = {};
  @observable public catalog = {};
  @observable public editLock = {};
  @observable public editAuditSwitch = {};
  @observable public mixedCourseware = {};

  get value() {
    const res = {};
    scenes.forEach((item) => {
      res[item] = this[item] || defaults;
    });
    return res;
  }

  get params() {
    return { type: 'USER_GUIDE', key: alo7Account.uuid };
  }

  init() {
    if (!this.root.auth.ready) return null;
    nx.$api.custom_parameter_show(this.params).then((res) => {
      const data = res.value;
      scenes.forEach((item) => nx.mix(this[item], defaults, nx.get(data, item)));
    });
  }

  save() {
    const { key, type } = this.params;
    nx.$api.custom_parameter_update({
      key,
      body: {
        type,
        value: this.value,
      },
    });
  }
}
